(function () {
  if (window.__kwhCartDrawer) return;
  window.__kwhCartDrawer = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function parse(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  // Inhalt des Warenkorbs neu aufbauen, ohne die Schublade zu schließen
  function refresh(sections, itemCount) {
    var d = drawer();
    if (!d || !sections) return;
    if (sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer'], '.drawer__inner');
      var target = d.querySelector('.drawer__inner');
      if (inner !== null && target) target.innerHTML = inner;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleHtml = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
    }
    if (typeof itemCount === 'number') d.classList.toggle('is-empty', itemCount === 0);
  }

  function post(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function currentCodes() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).map(function (c) { return c.code; });
      });
  }

  function setMsg(text, ok) {
    var msg = document.querySelector('[data-kwh-discount-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-error', !ok);
    msg.classList.toggle('is-ok', !!ok);
  }

  function openDisc() {
    var panel = document.querySelector('[data-kwh-panel="disc"]');
    if (panel) panel.hidden = false;
    var t = document.querySelector('[data-kwh-tool="disc"]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function applyCodes(codes) {
    return post('/cart/update.js', { discount: codes.join(',') });
  }

  // Upsell: Variante wechseln
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-kwh-upsell-select]');
    if (!sel) return;
    var card = sel.closest('[data-kwh-upsell]');
    var opt = sel.options[sel.selectedIndex];
    var btn = card.querySelector('[data-kwh-upsell-add]');
    var price = card.querySelector('[data-kwh-upsell-price]');
    var compare = card.querySelector('[data-kwh-upsell-compare]');
    if (btn) btn.dataset.variantId = sel.value;
    if (price && opt) price.textContent = opt.dataset.price;
    if (compare && opt) {
      compare.textContent = opt.dataset.compare || '';
      compare.hidden = !opt.dataset.compare;
    }
  });

  // Notiz speichern (mit kurzer Verzögerung)
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-kwh-note]');
    if (!note) return;
    var msg = document.querySelector('[data-kwh-note-msg]');
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value }),
      }).then(function () {
        if (msg) msg.textContent = 'Notiz gespeichert';
      });
    }, 600);
  });

  document.addEventListener('click', function (e) {
    // Notiz oder Rabatt aufklappen
    var tool = e.target.closest && e.target.closest('[data-kwh-tool]');
    if (tool) {
      var name = tool.dataset.kwhTool;
      document.querySelectorAll('[data-kwh-panel]').forEach(function (panel) {
        var open = panel.dataset.kwhPanel === name && panel.hidden;
        panel.hidden = !open;
      });
      document.querySelectorAll('[data-kwh-tool]').forEach(function (t) {
        var panel = document.querySelector('[data-kwh-panel="' + t.dataset.kwhTool + '"]');
        t.setAttribute('aria-expanded', panel && !panel.hidden ? 'true' : 'false');
      });
      var opened = document.querySelector('[data-kwh-panel="' + name + '"]:not([hidden]) textarea, [data-kwh-panel="' + name + '"]:not([hidden]) input');
      if (opened) opened.focus();
      return;
    }

    // Upsell in den Warenkorb
    var add = e.target.closest && e.target.closest('[data-kwh-upsell-add]');
    if (add) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      post('/cart/add.js', { items: [{ id: Number(add.dataset.variantId), quantity: 1 }] })
        .then(function (res) {
          if (res.status) {
            add.removeAttribute('aria-busy');
            return;
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { refresh(res.sections, cart.item_count); });
        })
        .catch(function () { add.removeAttribute('aria-busy'); });
      return;
    }

    // Upsell Slider
    var nav = e.target.closest && e.target.closest('[data-kwh-scroll]');
    if (nav) {
      var track = nav.closest('.kwh-cd__upsell').querySelector('[data-kwh-track]');
      if (track) track.scrollBy({ left: Number(nav.dataset.kwhScroll) * track.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    // Rabattcode entfernen
    var rm = e.target.closest && e.target.closest('[data-kwh-discount-remove]');
    if (rm) {
      var code = rm.dataset.kwhDiscountRemove;
      currentCodes()
        .then(function (codes) {
          return applyCodes(codes.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }));
        })
        .then(function (res) { refresh(res.sections, res.item_count); });
    }
  });

  // Rabattcode einlösen
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-kwh-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = (input.value || '').trim();
    if (!code) return;
    var btn = form.querySelector('button');
    btn.disabled = true;
    currentCodes()
      .then(function (codes) {
        if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) return null;
        return applyCodes(codes.concat([code])).then(function (res) {
          if (!Array.isArray(res.discount_codes)) {
            refresh(res.sections, res.item_count);
            return;
          }
          var found = (res.discount_codes || []).find(function (c) {
            return c.code.toLowerCase() === code.toLowerCase();
          });
          if (!found || !found.applicable) {
            // ungültigen Code wieder entfernen
            return applyCodes(codes).then(function (res2) {
              refresh(res2.sections, res2.item_count);
              openDisc();
              setMsg('Dieser Rabattcode ist ungültig oder gilt nicht für deinen Warenkorb.', false);
            });
          }
          refresh(res.sections, res.item_count);
          openDisc();
          setMsg('Rabattcode ' + found.code.toUpperCase() + ' wurde eingelöst.', true);
        });
      })
      .catch(function () {
        setMsg('Das hat leider nicht geklappt. Bitte versuche es erneut.', false);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  });
})();
